import Push from 'push.js';

export default class NotificationManager {

    createPush(title, body) {
        try {
            Push.create(title, body)
                .catch(e => {
                    console.log(e);
                });
        }
        catch (e) {
            console.log(e);
        }
    }

    /**
     * user full name
     * @param user {string}
     * Message instance
     * @param message {Message}
     */
    newMessage(user, message) {
        this.createPush(user, {
            body: message.notificationBody(),
            timeout: 4000,
            onClick: function () {
                window.focus();
                this.close();
            }
        });
    }

    /**
     * @param room {Room}
     * @param user
     * @param message {Message}
     */
    userIn(room, user, message) {
        this.createPush(room.title, {
            body: message.notificationBodyIn(user),
            timeout: 4000,
            onClick: function () {
                window.focus();
                this.close();
            }
        });
    }

    /**
     * @param room {Room}
     * @param user
     * @param message {Message}
     */
    userOut(room, user, message) {
        this.createPush(room.title, {
            body: message.notificationBodyOut(user),
            timeout: 4000,
            onClick: function () {
                window.focus();
                this.close();
            }
        });
    }

}